// extracted by mini-css-extract-plugin
export default {"inputContainer":"Invite_inputContainer__u28Uf","inputText":"Invite_inputText__V7xu9"};